module.exports = __webpack_public_path__ + "static/media/dashboard-banner-nick.ea6fcc77.png";